"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);



// "Today, 9:42 AM", "Yesterday, 5:51 PM", "Oct 27, 3:14 PM", with the year
// when it isn't this one.
 const formatEventTime = (iso) => {
  const at = _moment2.default.call(void 0, iso)
  const date = at.isSame(_moment2.default.call(void 0, ), 'year') ? 'MMM D, h:mm A' : 'MMM D, YYYY, h:mm A'
  return at.calendar(null, {
    sameDay: '[Today], h:mm A',
    lastDay: '[Yesterday], h:mm A',
    lastWeek: date,
    sameElse: date,
  })
}; exports.formatEventTime = formatEventTime

 const firstName = (name) => _nullishCoalesce(name.trim().split(/\s+/)[0], () => ( '')); exports.firstName = firstName

// The patient card's line: "viewed the chat", "exported the chat".
 const accessVerb = (e) => {
  if (e.Action === 'chat.viewed') return 'viewed the chat'
  if (e.Action === 'chat.exported') return 'exported the chat'
  return e.ActionLabel.toLowerCase()
}; exports.accessVerb = accessVerb
